import { render } from "./elearningCourseQuiz.vue?vue&type=template&id=e0bfa7dc"
import script from "./elearningCourseQuiz.vue?vue&type=script&lang=js"
export * from "./elearningCourseQuiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/elearningCourseQuiz.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0bfa7dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0bfa7dc', __exports__)) {
    api.reload('e0bfa7dc', __exports__)
  }
  
  module.hot.accept("./elearningCourseQuiz.vue?vue&type=template&id=e0bfa7dc", () => {
    api.rerender('e0bfa7dc', render)
  })

}


export default __exports__